// extracted by mini-css-extract-plugin
export default {"container":"FullTokenHistory_container__HbnxC","close":"FullTokenHistory_close__ZBlZb","lineBreak":"FullTokenHistory_lineBreak__3Y+1z"};